
import React from 'react';
import { Coins, Shield, Truck, Award } from 'lucide-react';

const WhyChooseUs = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-fabre-gray mb-4">
            Pourquoi choisir Groupe Fabre pour vos métaux ?
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Leader du recyclage des métaux en Occitanie, nous garantissons les meilleurs prix 
            et un service professionnel adapté à vos besoins.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="bg-red-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Coins className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="font-bold text-gray-800 mb-2">Prix Attractifs</h3>
            <p className="text-gray-600 text-sm">
              Cours actualisés en temps réel pour vous garantir les meilleurs prix du marché
            </p>
          </div>
          
          <div className="text-center">
            <div className="bg-red-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Shield className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="font-bold text-gray-800 mb-2">Expertise Reconnue</h3>
            <p className="text-gray-600 text-sm">
              Plus de 25 ans d'expérience dans l'identification et la valorisation des métaux
            </p>
          </div>
          
          <div className="text-center">
            <div className="bg-red-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Truck className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="font-bold text-gray-800 mb-2">Collecte Rapide</h3>
            <p className="text-gray-600 text-sm">
              Service de collecte sur site pour les gros volumes, intervention sous 48h
            </p>
          </div>
          
          <div className="text-center">
            <div className="bg-red-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Award className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="font-bold text-gray-800 mb-2">Service Certifié</h3>
            <p className="text-gray-600 text-sm">
              Traçabilité complète et certificats de destruction pour vos métaux
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
